import {ChangeDetectionStrategy, Component, OnInit, inject, signal} from '@angular/core';
import {Title} from '@angular/platform-browser';

import {PortalConfig} from "@shared/portal-config";

@Component({
    selector: 'app-forbidden-page',
    templateUrl: './forbidden-page.component.html',
    styleUrls: ['./forbidden-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ForbiddenPageComponent implements OnInit {
    private readonly titleService = inject(Title);
    private readonly config = inject(PortalConfig);

    readonly supportMessage = signal<string>('');

    ngOnInit(): void {
        this.titleService.setTitle('Portal - Error');
        this.supportMessage.set(this.config.supportMessage);
    }
}
